/**
 * Guards for links that arrive from outside the bundle.
 *
 * `hosted_verification_url` is handed to us by the API, which got it from
 * Stripe. That is a short chain of trust, but it is still a value we put
 * straight into a navigation, and the screens that use it have no business
 * deciding what a safe scheme is. Anything that is not parseable https — a
 * `javascript:` string, a relative path, an empty value from a field Stripe
 * did not publish — reads as absent, and the caller renders no button rather
 * than a dead or dangerous one.
 */
export const safeHttpsUrl = (url) => {
	try {
		return new URL(url).protocol === 'https:' ? url : null;
	} catch {
		return null;
	}
};
